import { Component } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'demo-upp-barcode-display',
    templateUrl: './demo-upp-barcode-display.html',
    styleUrls: ['../demo-common.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemoUppBarcodeDisplayComponent {
    form = new FormGroup({
        barcode: new FormControl<string | null>('8412345678901'),
    });

    mode: 'VIEW' | 'EDIT' = 'EDIT';
    disabled = false;

    constructor(private change: ChangeDetectorRef) {
    }

    toggleMode(): void {
        this.mode = this.mode === 'EDIT' ? 'VIEW' : 'EDIT';
        this.change.markForCheck();
    }

    toggleDisabled(): void {
        this.disabled = !this.disabled;
        if (this.disabled){
            this.form.disable();
        }
        else {
            this.form.enable();
        }
        this.change.markForCheck();
    }

    clearValue(): void {
        this.form.patchValue({ barcode: null });
        this.change.markForCheck();
    }
}
